import { RESERVATION_LIST_PARAMS } from '../../../utils/constants/QueryParamWhitelists';
import { BASE_RESERVATIONS_PATHNAME, RESERVATIONS_TYPE } from '../constants';

export const mapToReservationsLink = (tab = RESERVATIONS_TYPE.UPCOMING) => {
  const search = `?${RESERVATION_LIST_PARAMS.TAB}=${tab}`;
  const pathname = BASE_RESERVATIONS_PATHNAME;

  return { pathname, search };
};
